export class PdfUploaderContainer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.render();
        this.init();
    }

    init() {
        this.initEventHandlers();
    }

    render() {
        const label = document.createElement("label");
        label.classList.add('pdf-uploader-label')
        label.textContent = "PDF Resource";
        const fileUploader = document.createElementNS("http://www.w3.org/1999/xhtml", "file-uploader");

        const pdfFilenameEl = document.querySelector('input[name="pdf_filename"]');
        fileUploader.dataset.pdf_filename = pdfFilenameEl.value;

        this.appendChild(label);
        this.appendChild(fileUploader);
    }

    initEventHandlers()
    { 
    }


}

customElements.define('pdf-uploader-container', PdfUploaderContainer);

